import useAsyncData from "../../../../hooks/use-async-data";
import orderService from "../../order.service";
import OrderTransportingOrderAvailableDrivers from "./order-transporting-order-available-drivers";
import OrderTransportingOrderAvailableDriversParams from "./order-transporting-order-available-drivers-params";

const useOrderTransportingOrderAvailableDrivers = () => {
  const { data, isError, isLoading, setData, setIsError, setIsLoading } =
    useAsyncData<OrderTransportingOrderAvailableDrivers>([], false);

  const load = async (
    params: OrderTransportingOrderAvailableDriversParams,
    signal: AbortSignal,
  ): Promise<void> => {
    setIsLoading(true);
    setIsError(false);

    try {
      const transportingOrderAvailableDrivers =
        await orderService.getAvailableDrivers(params, signal);

      setData(transportingOrderAvailableDrivers);
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useOrderTransportingOrderAvailableDrivers;
